import { render, staticRenderFns } from "./CreateViewBottomSheet.vue?vue&type=template&id=18642756"
import script from "./CreateViewBottomSheet.vue?vue&type=script&lang=js"
export * from "./CreateViewBottomSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports